/* eslint-disable consistent-return */
/* eslint-disable no-useless-return */
export const getByDotNotation = (obj, path) => {
	try {
		if (!obj || !path) return;
		const keys = path.split('.');
		let result = obj;

		for (const key of keys) {
			if (result && Object.prototype.hasOwnProperty.call(result, key)) {
				result = result[key];
			} else {
				return;
			}
		}

		return result;
	} catch { return; }
};
